// src/api/client.js
import axios from 'axios';

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:Z|[+-]\d{2}:?\d{2})?$/;

export function handleDates(body: any) {
  if (body === null || typeof body !== 'object') return;
  for (const key of Object.keys(body)) {
    if (typeof body[key] === 'string' && isoDateFormat.test(body[key])) {
//      console.log(`Converted ${key} ${body[key]} to ${new Date(body[key])}`)
      body[key] = new Date(body[key]);
    } else if (typeof body[key] === 'object') {
      handleDates(body[key]);
    }
  }
}

export function createAxiosInstance() {
  return axios.create({
    transformResponse: [data => {
      let parsed = data;

      try {
        parsed = JSON.parse(data);
        handleDates(parsed);  
      } catch {
        
      }

      return parsed;
    }]
  });
}

export const publicAxios = createAxiosInstance();